export const isContactPageUrl = pathname => {
  const contactPageRegex = /\/contacts\/\d+\/(contact|record\/0-1)\/(\d+)\/*(\?[A-Za-z=-]+)*$/;
  const matches = pathname.match(contactPageRegex);
  return matches;
};
export const getContactIdFromUrl = url => {
  const pathname = new URL(url).pathname;
  const matches = isContactPageUrl(pathname);
  return Array.isArray(matches) ? matches[2] : undefined;
};